/*
 * 此文件用于弹出框的价格走势
 * @Author: wanghui
 * @date: 2019/03/20
 */

var PopupTrend = {
    init: highchart_init,
    popup_dom: null,
    dp_id: '',
    istb: false,
    config: config,
    quan_price: 0,
    show_promo_s: true,
};

var price_status_obj = {
    '-2': {
        trend: -2,
        txt: '历史最低',
        icon_class: 'i-lowest'
    },
    '-1': {
        trend: -1,
        txt: '价格下降',
        icon_class: 'i-down'
    },
    '0': {
        trend: 0,
        txt: '价格平稳',
        icon_class: 'i-steady'
    },
    '1': {
        trend: 1,
        txt: '价格上涨',
        icon_class: 'i-up'
    }
};
var currency = '&yen;';

var one_day = 3600 * 24 * 1e3;
var max_point_mark_symbol = "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAABGdBTUEAALGPC/xhBQAAALpJREFUGBmNUDEOwjAMtF3CUgaQ4AsI8QjExJaBrU/sxpCNCfEIhPhCkWCgC6E1uaitEEiAJTvO+eKczdSYWjumupxSpcMIJXwlSU/s3Bl3RlC7mpH3c+QfZsyB3fbIsZO/LUipV5Q+8zUvQTaiu0lq8tDqQWawl/hdKIB0r2itqiM4cmB4BI60mtpOsdCEDgu65bXwLRfCdMGg6Z3YYYEjWAEIEN5PaMPMFzjyOAyKWBPOv9YDIuzXwp9OElq9UW/exAAAAABJRU5ErkJggg==)";
var min_point_mark_symbol = "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAABGdBTUEAALGPC/xhBQAAALlJREFUGBmNUEEKwkAMTNJWPFpQ8AVWvPYufkG86Av14h/Ee69i/YKCHqV1d90J2yIKamCX7GR2MglTiLxc9cXWI9dxPUBc8c1Kciqy9UXfuPJyMXZsJ8jfg50cimx7ZCg5vk/JShyd0yXV0UzJidmZwXVDYh/suntBOxSUVMVzcpzq8blivgaONJ5aJZULV1AHR17xb7lgOiV4Tx/EgIETYwVEZgjj3hO1Fpph/G9wGCp/radp92vhT/hSX1+AfZcBAAAAAElFTkSuQmCC)";
var min_prom_point_mark_symbol = "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAABGdBTUEAALGPC/xhBQAAAKxJREFUGBljZICC/8vURBj+/lRjYGIQAAv9Y/jAwMx+izHq1hsQnxFE/F+moMHw/48WiI0BGFmuMUY9uMEINun/NzuGf/9ZGBiZIoAKHaCKDzD8/7eCgYnxDwMj1yEWqHVAs8GKApFMDASKAbn/l4DUMMHdhDAJSS3UdKC7QVqIAkwMIN9BwAEsOiBiQDUsoCBg+P9NAuxwsJvQPMMIDBhQMIFMISp4YNYRCnAAnAhC9E86zfAAAAAASUVORK5CYII=)";
var steady_point_mark_symbol = "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAABGdBTUEAALGPC/xhBQAAALZJREFUGBmNkD0KAkEMhfNmBkQrCwtPoGLhEcQrbOfeT1iPIR5hC1HPYGGlCDsT5y2bZgU1xfyELy/Jg3RRXnTiH80MPoyZ0tjc4yhcqzlu/INHWb8WSH7Jdz/UxVO1GpxBJTzj2omEKLqFyoawQg5esE8ijQ79MbBdAqSDClPMBUXMBwQ7Ms5mMiUDeVuOTO74XzhuR5Qz9UssRybQgrzMlIO3M30uIy1DlbLWbE/8bo+1+2X4G5CqX1LIiO6vAAAAAElFTkSuQmCC)";
var current_promotions_ds = [];
var current_promotions_cd = [];
var added_s = [];
var added_promo_s = [];

var _date = new Date();
var _year = _date.getFullYear();
var _month = _date.getMonth() + 1;
var _day = _date.getDate();
var now_timestamp = new Date(_year + '-' + _month + '-' + _day).getTime();

var base_chart_options = {
    chart: {
        type: 'line',
        spacing: [10, 0, 0, 0],
        events: {
            load: function() {
                this.renderer.image('https://www.gwdang.com/static_page/gameplus/img/logo_mark@2x.png', this.xAxis[0].left + 519, this.xAxis[0].top + this.xAxis[0].height - 95, 127, 60)
                    .add();
            }
        }
    },
    title: '',
    tooltip: {
        enabled: false,
        shadow: false,
        shared: false,
        shape: 'square',
        dateTimeLabelFormats: {
            day: '%Y/%m/%e',
            minute: '%Y/%m/%e',
            second: '%Y/%m/%e',
            hour: '%Y/%m/%e %H:%M'
        },
        useHTML: true,
        positioner: function positioner(labelWidth, labelHeight, point) {
            var position = {
                x: point.plotX + this.chart.plotLeft,
                y: this.chart.plotHeight / 2 - labelHeight / 2 + 45
            };
            if (point.plotX + labelWidth > this.chart.plotWidth - 10) {
                position.x = point.plotX - labelWidth + this.chart.plotLeft;
                position.y = this.chart.plotHeight / 2 - labelHeight / 2 + 45;
            }

            return position;
        },
        formatter: function formatter() {
            var fontFamily = "MicrosoftYaHei,Arial, Helvetica, sans-serif";
            var x = new Date(this.point.x - 3600000 * 8);
            var year = x.getFullYear();
            var month = x.getMonth() + 1;
            var day = x.getDate();
            var timeStr = year + '/' + month + '/' + day;
            return '<table style="table-layout: fixed;width:100%;font-family: '+fontFamily+';">' +
                '<tr style="line-height:14px;">' +
                '<td colspan="3" style="padding:0;text-align: center;font-weight: bold;font-size:12px;color:#4a4a4a">'+timeStr+'</td>' +
                '</tr>' +
                '<tr style="font-size:12px;color:#4a4a4a;line-height:14px;">' +
                '<td style="padding:0;width: 80px; text-align: left;">' +
                '<span style="color: '+this.point.color+';font-size:12px;line-height:14px;">\u25CF</span>'+this.series.name+':&nbsp;</td>\n' +
                '<td style="padding:0;text-align: right;width: 80px;font-weight: bold;color:'+this.point.color+'">'+Highcharts.numberFormat(this.point.y,2,'.',',')+'元</td>' +
                '</tr>' +
                '</table>';
        },
        backgroundColor: 'rgba(255,255,255,0.8)',
        borderColor: '#4d4d4d',
        borderWidth: 0.3,
        style: {
            padding: 0,
            minWidth: '200px'
        }
    },
    loading: {
        hideDuration: 1000,
        showDuration: 1000
    },
    legend: {
        enabled: false,
        itemStyle: {
            color: '#999999',
            fontWeight: 'normal'
        },
        symbolPadding: 10,
        symbolWidth: 20,
    },
    plotOptions: {
        series: {
            point: {
                events: {
                    mouseOver: function (event) {
                        show_point_detail(this);
                    },
                    mouseOut: function (event) {
                        hide_point_detail(this);
                    }
                }
            },
            events: {
                legendItemClick: function (event) {
                    // 页面价
                    if (event.target.index == 0) {
                        return false;
                    } else {
                    }
                }
            }
        },
        line: {
            states: {
                hover: {
                    enabled: false,
                    lineWidth: 1.25
                }
            }
        },
    },
    series: [],
    xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
            millisecond: '%m/%d',
            minute: '%m/%d',
            hour: '%m/%d',
            day: '%m/%d',
            week: '%m/%d',
            month: '%Y/%m'
        },
        labels: {
            style: {
                color: '#606060',
                fontSize: '12px',
                fontFamily: 'HelveticaNeue'
            },
        },
        lineColor: '#EDF1F3',
        tickWidth:0,
        minTickInterval: one_day,
        startOnTick: false,
        gridLineWidth: 1,
        gridLineColor: '#EDF1F3',
        crosshair: {
            dashStyle: 'ShortDot',
            width: 1.5,
            color: '#333333',
            snap: false
        },
        tickPositioner: function tickPositioner() {
            var positions = [];
            var min = this.min;
            var max = this.max;
            var minDate = new Date(min);
            var tick = 0;
            var mode = void 0;
            var months = 1;
            var plotWidth = this.chart.plotWidth;
            if (max - min > 300 * one_day) {     // 大于300天
                var s = new Date(minDate.getFullYear(), minDate.getMonth() + 1, 2);
                tick = s.getTime();
                var widthPerMonth = plotWidth / ((max - min) / (30 * one_day));
                while (months * widthPerMonth < 100) {
                    months++;
                }
                mode = 'nmonth';
            } else if (max - min > 64 * one_day) {   // 大于64天
                var _s = new Date(minDate.getFullYear(), minDate.getMonth() + 1, 2);
                tick = _s.getTime();
                mode = 'month';
            } else if (max - min > 10 * one_day) {   // 大于10天
                tick = min;
                mode = 'day';
            } else {    // 小于10天
                var _s2 = new Date(minDate.getFullYear(), minDate.getMonth(), minDate.getDate() + 1);
                tick = _s2.getTime();
                mode = 'hour';
            }

            while (tick - 3600000 * 15 <= max) {
                positions.push(tick - 3600000 * 15);
                switch (mode) {
                    case 'month':
                        var _s3 = new Date(tick);
                        var s1 = new Date(_s3.getFullYear(), _s3.getMonth() + 1, 2);
                        tick = s1.getTime();
                        break;
                    case 'day':
                        tick += 5 * one_day;break;
                    case 'hour':
                        tick += one_day;break;
                    case 'nmonth':
                        _s3 = new Date(tick);
                        s1 = new Date(_s3.getFullYear(), _s3.getMonth() + months, 2);
                        tick = s1.getTime();
                        break;
                }
            }

            let showingCenter = true;
            if (showingCenter) {
                var i = 0;
                while (positions[i] < this.min) {
                    i++;
                }
                positions = [positions[i], positions[positions.length - 1]];
            }

            switch (mode) {
                case 'month':
                case 'nmonth':
                    positions.info = {
                        unitName: 'month',
                        higherRanks: {}
                    };
                    break;
                default:
                    positions.info = {
                        unitName: 'day',
                        higherRanks: {}
                    };
            }
            return positions;
        }
    },
    yAxis: {
        title: {
            text: null
        },
        labels: {
            formatter: function () {
                return parseFloat(this.value)
            },
            style: {
                color: '#606060',
                fontSize: '12px',
                fontFamily: 'HelveticaNeue'
            }
        },
        gridLineColor: '#EDF1F3',
    },
    credits: {
        enabled: false
    },
};

function formatTimestamp(timestamp, delimiter) {
    delimiter = delimiter || '-';
    if ((timestamp+'').length == 10) {
        timestamp *= 1e3
    }

    let d = new Date(parseInt(timestamp))
    let y = d.getFullYear()
    let m = d.getMonth()+1
    if (m < 10) m = '0' + m
    let date = d.getDate()
    if (date < 10) date = '0' + date

    return y + delimiter + m + delimiter + date
}

/**
 * assemble the promotion info txt
 * @param msg_arr Array
 * @return {string}
 */
let popup_packagePromoMsg = function (msg_arr) {
    let txt = [];
    msg_arr.forEach(function (item) {
        let show_txt = item.text;
        let t = show_txt.split('-');
        if (t.length > 1) {
            show_txt = "满" + t[0] + "减" + t[1];
        } else {
            show_txt = show_txt.replace(';', '；');
        }

        txt.push(item.tag + ': ' + show_txt)
    })

    return txt
}

/**
 * mouse hover trend series
 * @param point
 */
let show_point_detail = function (point) {
    let chart = point.series.chart;
    let renderTo = chart.renderTo;
    let hover_dom = $(renderTo).siblings('.hover-price-info')
    let ymj_price = parseFloat(point.y).toFixed(2);
    let dsj_price = 0;
    let cdj_price = 0;

    hover_dom.find('.current-date').text(formatTimestamp(point.x,'.'))

    // 有到手价
    let promo_dsj = current_promotions_ds[point.x];
    if (promo_dsj !== undefined) {
        hover_dom.find('.info-item#dsj').show()
        dsj_price = parseFloat(promo_dsj.price / 1e2).toFixed(2)
        if (ymj_price == dsj_price) {
            ymj_price = ymj_price = parseFloat(promo_dsj.ori_price / 1e2).toFixed(2)
        }

        hover_dom.find('.info-item#dsj .dsj-price').html(currency == '&#20870;' ? dsj_price + currency : currency + dsj_price)
        hover_dom.find('.info-item#dsj .promo-msg').html(popup_packagePromoMsg(promo_dsj.msg).join('; '))
    }

    // 有到手价(多件)
    if (chart.series.length === 2) {
        var promo_cd = current_promotions_cd[point.x];
    }
    if (promo_cd !== undefined) {
        hover_dom.find('.info-item#cdj').show()
        cdj_price = parseFloat(promo_cd.price / 1e2).toFixed(2)
        if (ymj_price == cdj_price) {
            ymj_price = parseFloat(promo_cd.ori_price / 1e2).toFixed(2)
        }

        hover_dom.find('.info-item#cdj .cdj-price').html(currency == '&#20870;' ? cdj_price + currency : currency + cdj_price)
        hover_dom.find('.info-item#cdj .promo-msg').html(popup_packagePromoMsg(promo_cd.msg).join('; '))
    }

    if (promo_dsj === undefined && promo_cd === undefined) {
        hover_dom.find('.info-item#ymj .title').html('页面价/到手价(单件)').css({'width':'120px'});
    } else {
        hover_dom.find('.info-item#ymj .title').html('页面价').css({'width':'75px'})
    }

    if (PopupTrend.istb) {
        if (point.x == now_timestamp && PopupTrend.quan_price) {
            hover_dom.find('.info-item#ymj .title').html('券后价').css({'width':'75px'}).show()
            hover_dom.find('.info-item#ymj .colon').show()
        } else {
            hover_dom.find('.info-item#ymj .title,.info-item#ymj .colon').hide()
        }
    } else {
        hover_dom.find('.info-item#ymj .title,.info-item#ymj .colon').show()
    }

    hover_dom.find('.info-item#ymj .ymj-price').html(currency == '&#20870;' ? ymj_price + currency :currency + ymj_price)
    hover_dom.addClass('active');
}

/**
 * mouse leave trend series
 * @param point
 */
var hide_point_detail = function (point) {
    var chart = point.series.chart;
    var renderTo = chart.renderTo;
    var hover_dom = $(renderTo).siblings('.hover-price-info')

    hover_dom.find('.info-item#dsj,.info-item#cdj').hide()
    hover_dom.removeClass('active');
}

/**
 * 走势线上部的最大最小值
 *
 * @param trend_area
 * @param price_status
 * @param ymj
 * @param cdj
 * @param hover_height
 * @param chart_m_t chart margin-top
 */
var setPriceInfo = function (trend_area,price_status, ymj, cdj, hover_height, chart_m_t) {
    ymj = ymj || null;
    cdj = cdj || null;
    hover_height = hover_height || 58;
    chart_m_t = chart_m_t || 0;
    trend_area.find('.p-status .status-icon').attr('class','').attr('class', 'status-icon ' + price_status.icon_class);
    trend_area.find('.p-status .status-txt').data('s-d', price_status.trend).text(price_status.txt);

    trend_area.find('.hover-price-info').css({'height': hover_height+'px'})
    if (chart_m_t) {
        trend_area.find('.area-content').css({'margin-top': chart_m_t+'px'})
    }

    var ymj_dom = trend_area.find('.info-item#ymj');
    if (ymj) {
        ymj_dom.find('.min .min-price').html(currency == '&#20870;' ? ymj.min+currency : currency + ymj.min);
        if (ymj.max == ymj.min) {
            ymj_dom.find('.max').hide();
            ymj_dom.find('.min').addClass('price-steady');
            ymj_dom.find('.min .min-title').text('现价');
            ymj_dom.find('.min .tag').hide()
        } else {
            ymj_dom.find('.max .max-price').html(currency == '&#20870;' ? ymj.max + currency : currency + ymj.max);
            ymj_dom.find('.date').text('(' + ymj.min_date + ')');
        }

        if (PopupTrend.istb) {
            ymj_dom.find('.min .tag').hide()
        }
    }

    var cdj_dom = trend_area.find('.info-item#cdj');
    if (cdj && cdj.min && (cdj.min != ymj.min || (cdj.min == ymj.min && cdj.min_date != ymj.min_date))) {
        cdj_dom.find('.min .min-price').html(currency == '&#20870;' ? cdj.min + currency : currency + cdj.min);
        cdj_dom.find('.date').text('(' + cdj.min_date + ')');
        if (ymj.max == ymj.min) {
            cdj_dom.find('.max').hide();
        } else {
            cdj_dom.find('.max').css('width', ymj_dom.find('.max').width() + 'px');
        }

        if (PopupTrend.dp_id) {
            cdj_dom.find('.morePromo').attr('href', (location.hostname.includes('bijiago') ? '/bjg': '') + '/v2/trend/'+ PopupTrend.dp_id +'.html?static=true').show();
        }
    } else {
        cdj_dom.hide();
    }
}

/**
 * 补点，将走势数据补成每一天
 * @param serie
 * @param draw_last_point 天猫淘宝优惠券时，标记下最后一个点
 * @return {*}
 */
var patchPoint = function (serie, draw_last_point) {
    draw_last_point = draw_last_point || false;
    if (serie.data && serie.data.length) {
        var a_day = one_day / 1e3;
        var tmp = [];
        tmp.push(serie.data[0]);
        if (tmp[0].is_drawn === undefined) {
            tmp[0].is_drawn = 0;
        }

        serie.data.forEach(function (point, i) {
            if (i === 0) return;

            if (point.is_drawn === undefined) {
                point.is_drawn = 0;
            }

            if (i === serie.data.length-1 && !point.is_drawn && draw_last_point) {
                point.is_drawn = 1;
            }

            if ((point.x - tmp[tmp.length-1].x) > a_day) {
                var t = {
                    x: tmp[tmp.length-1].x + a_day,
                    y: tmp[tmp.length-1].y,
                    is_drawn: 0,
                };

                while (t.x < point.x) {
                    tmp.push(t);
                    t = {
                        x: tmp[tmp.length-1].x + a_day,
                        y: tmp[tmp.length-1].y,
                        is_drawn: 0,
                    }
                }

                if (t.x == point.x) {
                    tmp.push({
                        x: point.x,
                        y: point.y,
                        is_drawn: point.is_drawn,
                    });
                }
            } else {
                tmp.push(point);
            }
        })

        serie.data = tmp;
    }
    return serie;
};

/**
 * 格式化serie
 * @param serie
 * @param is_prom 是否是促销
 * @param coupon_amount 处理优惠券
 * @param show_no_puzzle_marker 出否处理空心点
 * @return {{max: {id: number, x: number, y: string}, min: {id: number, x: number, y: string}, data: Array, x2index: Array}}
 */
var format_serie = function (serie, is_prom, coupon_amount, show_no_puzzle_marker) {
    is_prom = is_prom || false;
    coupon_amount = coupon_amount || 0;
    show_no_puzzle_marker = show_no_puzzle_marker || false;
    var temp = [];
    var x2index = [];
    var start_stamp = '';
    var end_stamp = '';

    var max = {
        id: null,
        x: null,
        y: 0
    };
    var min = {
        id: null,
        x: null,
        y: 99999999
    };

    var data_len = serie.data.length;
    serie.data.forEach(function (item, index) {
        var id = 'serie_'+index;
        if (is_prom) {
            id = 'serie_prom_'+index;
        }
        var x = item.x * 1e3;
        var y = parseFloat(item.y / 1e2);

        if (index === 0) {
            start_stamp = x
        }

        if (index === (data_len-1)) {
            end_stamp = x
        }

        if (index === (data_len-1) && !is_prom) {
            if (coupon_amount && (y - coupon_amount) > 0) {
                y = parseFloat(y - coupon_amount);
            }
        }

        x2index[x] = index;
        var point = {
            id: id,
            x: x,
            y: y,
            marker: {
                enabled: false
            }
        };

        // 添加空心点
        if (show_no_puzzle_marker && item.is_drawn == 1) {
            point.marker = {
                enabled: true,
                fillColor: 'rgba(255, 255, 255, 1)',
                radius: 2.5,
                symbol: 'circle',
                lineColor: '#5ACFFB',
                lineWidth: 1,
                states: {
                    hover: {
                        enabled: true
                    }
                }
            };
        }

        if (max.y <= y) {
            max.id = index;
            max.x = x;
            max.y = y;
        }

        if (min.y >= y) {
            min.id = index;
            min.x = x;
            min.y = y;
        }

        temp.push(point);
    });

    if (coupon_amount && serie.trend >= 0) {
        serie.trend = -1;
    }

    return {
        max: max,
        min: min,
        data: temp,
        x2index: x2index,
        is_promo: serie.is_promo,
        trend: serie.trend,
        site_name: serie.site_name,
        series_name: serie.series_name,
        start_stamp: start_stamp,
        end_stamp: end_stamp,
    }
};

/**
 * 重新定位最大最小值，用于promo_series
 * @param serie
 * @param p_serie
 * @return {*}
 */
var relocate_max_min = function (serie, p_serie) {
    var max = {
        id: null,
        x: null,
        y: 0
    };
    var min = {
        id: null,
        x: null,
        y: 99999999
    };

    serie.data.forEach(function (point, index) {
        if (point.y) {
            var t= {
                id: index,
                x:  point.x,
                y:  point.y
            };

            if (p_serie.x2index[point.x] !== undefined && point.y < p_serie.data[p_serie.x2index[point.x]].y) {
                if (point.y >= max.y) {
                    max = t;
                }
                if (point.y <= min.y) {
                    min = t;
                }
            }
        }
    })

    serie.max = max;
    serie.min = min;

    return serie
}

/**
 * 标记出最高和最低
 * @param serie
 * @return {*}
 */
var mark_max_min = function (serie) {
    if (serie.min.x) {

        if (serie.max && serie.max.y == serie.min.y) {
            if (serie.is_promo) {
            } else { // 价格是一条直线
                serie.data[serie.data.length-1].marker = {
                    enabled: true,
                    symbol: steady_point_mark_symbol
                };
            }
        } else {
            if (serie.max.id >= 0 && serie.max.id !== serie.min.id && !serie.is_promo) {
                serie.data[serie.max.id].marker = {
                    enabled: true,
                    symbol: max_point_mark_symbol
                };
            }

            serie.data[serie.min.id].marker = {
                enabled: true,
                symbol: serie.is_promo ? min_prom_point_mark_symbol : min_point_mark_symbol
            };
        }

        return serie;
    } else {
        return serie;
    }
}

/**
 * 多条线重合时导致线的颜色变深，清理重合部分
 * @param compare_series 蓝线
 * @param change_series  黄线
 * @return {*}
 */
var clear_series = function (compare_series, change_series) {
    var tmp_change = [];

    change_series.forEach(function (serie, index) {
        tmp_change[index] = [];

        if (compare_series[index]) {
            serie.data.forEach(function(point, point_i) {
                var compare_point_i = compare_series[index].x2index[point.x];
                if (undefined !== compare_point_i) {
                    if (point.y < compare_series[index].data[compare_point_i].y) {
                        if (tmp_change[index].indexOf(point_i) < 0) {
                            tmp_change[index].push(point_i)
                        }

                        if ((point_i+1 < serie.data.length) && tmp_change[index].indexOf(point_i+1) < 0) {
                            tmp_change[index].push(point_i+1)
                        }

                        if ((point_i-1 >= 0) && tmp_change[index].indexOf(point_i-1) < 0) {
                            tmp_change[index].push(point_i-1)
                        }
                    }
                }
            });
        }
        return serie;
    });

    change_series.map(function (serie, index) {
        serie.data.forEach(function (point, point_i) {
            if ($.inArray(point_i, tmp_change[index]) < 0) {
                if (point_i != (serie.data.length-1)) { // 除去最后一个点，防止最后一点两线没有相连
                    point.y = null;
                }
            }
        });

        return serie;
    });

    return change_series;
};

/**
 * 添加价格历史线
 * @param s
 * @return {*}
 */
function add_series(s) {
    var _s = patchPoint(s, PopupTrend.quan_price ? true:false);
    _s = format_serie(_s, false, PopupTrend.quan_price, true);
    _s = mark_max_min(_s);

    base_chart_options.series.push({
        name: s.series_name,
        data: _s.data,
        pointInterval: 24 * 3600 * 1000,
        lineWidth: 1.25,
        zIndex: 1000,
        color: '#5ACFFB'
    });

    return _s
}

/**
 * 添加促销线
 * @param s
 * @param price_s
 */
var add_promo_series = function (s, price_s) {
    price_s = price_s || null;
    var _s = patchPoint(s);
    _s = format_serie(_s, true, 0, false);

    if (price_s) {
        _s = relocate_max_min(_s, price_s);
        if (_s.min.x && (_s.min.x != price_s.min.x || _s.min.y != price_s.min.y)) {
            if (_s.min.x && _s.min.y < price_s.min.y) {
                _s = mark_max_min(_s);
            }
        }
    }

    var tmp = clear_series([price_s], [_s]);
    _s = tmp[0];

    if (_s.min.x && (_s.min.x != price_s.min.x || (_s.min.x == price_s.min.x && _s.min.y != price_s.min.y))) {
        base_chart_options.series.push({
            name: s.series_name,
            data: _s.data,
            pointInterval: 24 * 3600 * 1000,
            lineWidth: 1.2,
            zIndex: 999,
            color: '#FF9F22'
        });

        return _s
    }
    return false
}

var prepare_promos = function (promotions) {
    current_promotions_cd = [];
    current_promotions_ds = [];

    if (promotions) {
        promotions.map(function (p, index) {
            if ((p.time + '').length !== 13) {
                p.time *= 1e3;
                p.time = p.time + '';
            }

            if (p.no_puzzle == 1) {
                current_promotions_ds[p.time] = p
            } else {
                current_promotions_cd[p.time] = p
            }
            return p
        })
    }
}

/**
 * 一些清理工作
 */
var h_clear = function () {
    PopupTrend.popup_dom = null;
    PopupTrend.hover_dom = null;
    base_chart_options.series = [];
    added_s = [];
    added_promo_s = [];
    current_promotions_cd = [];
    current_promotions_ds = [];
}

/**
 * 走势图上部的价格信息
 *
 * @param trend_area
 * @param s1 history price series
 * @param s2 promotion series
 */
var ymj_cdj = function (trend_area, s1 = null, s2 = null) {
    s1 = s1 || null;
    s2 = s2 || null;
    if (!s1) {
        console.error('error ymj');
        return
    }
    var ymj = {
        max: parseFloat(s1.max.y).toFixed(2),
        min: parseFloat(s1.min.y).toFixed(2),
        min_date: formatTimestamp(s1.min.x,'.'),
    }

    var cdj = null;
    if (s2 && s2.min.id !== null) {
        var p_index = s1.x2index[s2.min.x]
        if (p_index >= 0 && s2.min.y < s1.data[p_index].y) {
            cdj = {
                max: parseFloat(s2.max.y).toFixed(2),
                min: parseFloat(s2.min.y).toFixed(2),
                min_date: formatTimestamp(s2.min.x,'.'),
            }
        }
    }

    if (cdj) {
        PopupTrend.show_promo_s = !0;
    } else {
        PopupTrend.show_promo_s = !1;
    }

    var counter = 1;
    var hover_height = 58;

    s1.data.forEach(function (point, index) {
        if (counter === 3) return

        if (current_promotions_ds[point.x] !== undefined && current_promotions_cd[point.x] !== undefined && cdj) {
            counter = 3;
        } else if (current_promotions_ds[point.x] !== undefined) {
            counter = 2;
        } else if (current_promotions_cd[point.x] !== undefined && cdj) {
            counter = 2;
        }
    })

    var chart_margin_top = 0;
    if (!cdj && s2 && s2.min.x) {
        chart_margin_top = 36;
    }
    switch (counter) {
        case 1:
            hover_height = 58;
            break;
        case 2:
            hover_height = 78;
            break;
        case 3:
            hover_height = 98;
            break;
    }

    setPriceInfo(trend_area, price_status_obj[s1.trend], ymj, cdj, hover_height, chart_margin_top);
}

function config(options) {
    h_clear();
    PopupTrend.popup_dom = options.popup_dom;

    if (options.dp_id !== undefined) {
        PopupTrend.dp_id = options.dp_id;
    }
    if (options.istb !== undefined) {
        PopupTrend.istb = options.istb;
    }
    if (options.quan_price !== undefined) {
        PopupTrend.quan_price = options.quan_price;
    }

    if (options.promotions !== undefined) {
        prepare_promos(options.promotions);
    }

    if (options.currency !== undefined) {
        currency = options.currency;
    }
}

function highchart_init(chart_id, options) {
    config(options)

    options.series.forEach(function (s1, index) {
        added_s.push(add_series(s1));
    })

    options.promo_series.forEach(function (s2, index) {
        var tmp_s = add_promo_series(s2, added_s[0]);
        if (tmp_s) {
            added_promo_s.push(tmp_s);
        }
    })

    // 处理头部的页面价和到手价(多件)的最大最小值
    ymj_cdj(options.popup_dom ,added_s[0], added_promo_s.length ? added_promo_s[0]: null);

    // before chart
    if (typeof options.callback_before_draw === 'function') {
        options.callback_before_draw.apply(this, [base_chart_options]);
    }

    base_chart_options.legend.enabled = options.show_legend;
    Highcharts.setOptions({ global: { useUTC: false, }});
    var hchart = new Highcharts.Chart(chart_id, base_chart_options);

    // after chart
    if (typeof options.callback_after_draw === 'function') {
        options.callback_after_draw.apply(this, [hchart]);
    }

    return hchart;
}

export default PopupTrend;
